/**
 * @overview ready service
 * @author Amir Absalyamov <mr.amirka@ya.ru>
 */

module.exports = require('./readyProvider')(window);
